import get from 'lodash/get';
import { omit } from 'utils/methods/helpers';
import startsWith from 'lodash/startsWith';
import { formatTimeDifference, isDate } from '../time';

export const gettingLanguageNames = (array, languages) => {
  if (!array || array.length < 1) return '-';
  const listOfLanguages = array.map(n => languages[n]);

  return listOfLanguages.join('; ');
};

export const getPersonName = data =>
  data.firstName != null && data.firstName !== ''
    ? `${get(data, 'firstName', '-')} ${get(data, 'lastName', '')}`
    : '-';

export const getDepartmentNamesArray = (globalDepartmentList, data) => {
  // data can be an object with a structure of {general:{},details:{}, operational:{}} or {}
  return globalDepartmentList
    .filter(f => {
      if (data?.general) {
        return getItemOrDefaultToValue(
          data.general,
          'departmentIds',
          [],
        ).includes(f.id);
      } else {
        return getItemOrDefaultToValue(data, 'departmentIds', []).includes(
          f.id,
        );
      }
    })
    .map(m => m.name);
};
export const getAssignedDepartmentList = (globalDepartmentList, data) => {
  return globalDepartmentList.filter(globalDepartment => {
    return getItemOrDefaultToValue(data, 'departmentIds', []).includes(
      globalDepartment.id,
    );
  });
};
export const getItemOrDefaultToValue = (mapItem, key, defaultValue) => {
  // eslint-disable-next-line no-prototype-builtins
  if (!mapItem || !mapItem.hasOwnProperty(key)) {
    //make sure that we have a map and key
    return defaultValue;
  }
  return mapItem[key] !== null ? get(mapItem, key, defaultValue) : defaultValue;
};

export const getItemOrNull = (mapItem, key) => {
  return mapItem[key] ? get(mapItem, key) : null;
};

export const getPhoneNumber = phone =>
  phone != null ? `${get(phone, 'prefix')} ${get(phone, 'number', '-')}` : '-';

export const getElapsedTime = (data, currentTime) => {
  if (startsWith(data.currentStatus, 'RESOLVED')) {
    return formatTimeDifference(data.startTime, data.currentStatusTimestamp);
  } else {
    return formatTimeDifference(data.startTime, currentTime);
  }
};

export const getValueOfObject = (data, desiredKey) => {
  const lists = get(data, desiredKey);

  return lists.map(item => {
    const list = Object.keys(item);

    return list.reduce(
      (acc, key) => ({
        ...acc,
        [key]: item[key]?.id ? item[key].id : item[key].value,
      }),
      {},
    );
  });
};

export const determineType = (val, useRating = true) => {
  switch (typeof val) {
    case 'number': //this is defaulted to showing as a rating else just use text
      if (useRating) {
        return 'rating';
      }
      return 'text';
    case 'boolean':
      return 'boolean';
    case 'string':
      if (isDate(val)) {
        return 'date';
      }
      return 'text';

    default:
      return 'text';
  }
};

export const transformArrayDisplay = (
  arrayData,
  omitted = [],
  useRating = true,
) => {
  return arrayData.map(item => {
    const objectKeyValue = Object.entries(item);
    return omit(
      objectKeyValue.reduce((acc, keyVal) => {
        const [key, val] = keyVal;
        if (typeof val === 'object') {
          return {
            ...acc,
            [key]: {
              value: val === null ? undefined : val?.name,
              type: determineType(val, useRating),
              label: val?.name,
              id: val === null ? undefined : val?.id,
            },
          };
        }
        return {
          ...acc,
          [key]: {
            value: val === null ? undefined : val,
            type: determineType(val, useRating),
            label: val,
          },
        };
      }, {}),
      omitted,
    );
  });
};

export const createDisplay = (data, array) => {
  return data.map(item => ({
    display: array.reduce(
      (acc, displayItem, index) =>
        index === 0
          ? acc.concat(`${item[displayItem]}: `)
          : acc.concat(`${item[displayItem]} `),
      '',
    ),
    ...item,
  }));
};

export const createURL = (data, array) => {
  return data.map(item => ({
    display: array.reduce(
      (acc, displayItem) => acc.concat(`${item[displayItem]} `),
      '',
    ),
    ...item,
  }));
};

export const nestedDisplay = data => {
  return data.map(item => ({
    display: item.name,
    ...item,
  }));
};

export const getCountryName = (countryCode, countryList) => {
  const data = countryList.find(country => country.id === countryCode);
  return data.countryName;
};

export const getValueFromConstantObject = ({
  constant,
  value,
  defaultValue,
  key = 'name',
}) => {
  if (constant && value) {
    const object = constant[value];
    return object ? object[key] : defaultValue;
  }

  return defaultValue;
};

export const convertIdToValue = ({ list, key, constant, defaultValue }) => {
  const item =
    typeof list === 'object'
      ? getItemOrDefaultToValue(list, key, defaultValue)
      : list;

  return getValueFromConstantObject({ constant, value: item });
};

export const convertValueToId = ({ list, value }) => {
  const findItem = Object.values(list).find(item => item.name === value);
  return findItem ? findItem.id : value;
};
